/* nooks-header.shopify.js — production cart + predictive search (gold-star UX build).
   Loads AFTER nooks-header.js (which owns scroll, panels, sub-menu, focus).

   Design goals:
   - INSTANT qty changes: optimistic UI updates the DOM immediately, then a debounced
     /cart/change.js call reconciles with the server. No full-section re-render on every tap.
   - No lost listeners: ALL cart interactions use event delegation bound once to #nk-header,
     so re-rendering line HTML never breaks the X / qty / remove buttons.
   - Correctness: the server response (authoritative cart JSON) reconciles totals, discounts,
     free-shipping bar, and per-line prices after each change.
   - Exposes window.nooksOpenCart()/nooksCartRefresh() for the instant.so/bundle shim.
*/
(function () {
  const H = document.getElementById('nk-header');
  if (!H) return;

  const CART = () => H.querySelector('#nk-cart');
  const threshold = parseFloat(H.dataset.freeShipping || '50') * 100;
  const curFmt = (cents, cur) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur || 'AUD' }).format(cents / 100);
  // PER TIN (Scout 2026-09-09, Debounce Baby): divide a line's cents by its qty and round to the
  // nearest cent so the drawer shows discounted price PER TIN, matching the Liquid render.
  const perTinCents = (cents, qty) => Math.round((cents || 0) / Math.max(1, qty || 1));
  const $all = s => H.querySelectorAll(s);

  let latest = null;           // last known authoritative cart JSON
  // SPEED (Scout 2026-09-09): seed `latest` from the inline boot JSON Liquid rendered, so the FIRST
  // +/- tap already has an authoritative snapshot to compute the optimistic subtotal from — no
  // waiting on the open-refresh fetch. Eliminates the first-tap subtotal/button lag.
  try {
    const _boot = H.querySelector('[data-nk-cart-boot]') || document.querySelector('[data-nk-cart-boot]');
    if (_boot && _boot.textContent.trim()) { const c = JSON.parse(_boot.textContent); if (c && c.items) latest = c; }
  } catch (e) {}
  var lastDiscSig = null;       // discount "signature" of the last-rendered cart (var: hoisted, no TDZ)
  let pending = {};            // line key -> desired quantity (optimistic)
  let pendingSeq = {};         // line key -> monotonic version of the last desired qty (race guard)
  let syncTimer = null;
  let inFlight = false;

  /* ---------------- rendering ---------------- */
  function paintTotals(cart) {
    $all('[data-nk-count]').forEach(e => e.textContent = cart.item_count);
    $all('[data-nk-subtotal]').forEach(e => { e.textContent = curFmt(cart.total_price, cart.currency); e.removeAttribute('data-nk-updating'); });
    const away = threshold - cart.total_price;
    $all('[data-nk-away]').forEach(e => e.textContent = away > 0
      ? curFmt(away, cart.currency).toUpperCase() + ' AWAY FROM FREE SHIPPING'
      : 'FREE SHIPPING UNLOCKED');
    const pct = Math.max(0, Math.min(100, Math.round(cart.total_price / threshold * 100)));
    $all('[data-nk-bar]').forEach(e => { e.style.width = pct + '%';
    // Update cart-level savings chip (2026-09-26)
    let totalSavings = 0;
    cart.items.forEach(item => {
      if (item.line_level_discount_allocations) {
        item.line_level_discount_allocations.forEach(d => {
          totalSavings += d.amount;
        });
      }
    });
    $all('[data-nk-cart-savings]').forEach(e => {
      if (totalSavings > 0) {
        e.textContent = 'YOU SAVE ' + curFmt(totalSavings, cart.currency);
        e.style.display = '';
      } else {
        e.style.display = 'none';
      }
    }); });
    $all('[data-nk-away]').forEach(e => e.removeAttribute('data-nk-updating'));
    // Reconcile the CART-LEVEL discount rows ([data-nk-disc]) from authoritative JSON so order
    // discounts (e.g. FOUNDING800 -$10) stay truthful without a section-render. (Scout 2026-09-09.)
    syncCartDiscounts(cart);
    const cartEl = CART();
    if (cartEl) cartEl.classList.toggle('nk-cart--empty', cart.item_count === 0);
  }

  // Rebuild the cart-level discount block to match Shopify's authoritative data. Mirrors the
  // Liquid: <div class="nk-cart__disc"><span>Discount · TITLE</span><span>−$x.xx</span></div>.
  function syncCartDiscounts(cart){
    const wrap = H.querySelector('[data-nk-disc]');
    if (!wrap) return;
    const apps = (cart.cart_level_discount_applications || []);
    wrap.innerHTML = apps.map(d => {
      const amt = curFmt(d.total_allocated_amount || 0, cart.currency);
      const title = (d.title || '').toString();
      return '<div class="nk-cart__disc"><span>Discount · ' + title.replace(/[<>&]/g,'') + '</span><span>−' + amt + '</span></div>';
    }).join('');
  }

  function paintLine(item, idx) {
    // Match by key first; fall back to POSITION (data-line) because Shopify REGENERATES the line
    // key on every cart mutation. Without the fallback, after one change the DOM holds a stale key,
    // paintLine can't find the line, and the NEXT tap sends the stale key -> server no-ops -> the
    // qty "bounces back". Matching by index and re-syncing data-key keeps taps valid. (Scout 2026-09-09)
    let line = H.querySelector('[data-nk-line][data-key="' + cssKey(item.key) + '"]');
    if (!line && typeof idx === 'number') {
      line = H.querySelector('[data-nk-line][data-line="' + (idx + 1) + '"]');
    }
    // Always re-sync the DOM key to the CURRENT server key so the next tap targets a valid line.
    if (line && line.dataset.key !== cssKey(item.key)) { line.dataset.key = cssKey(item.key); }
    if (!line) return;
    const q = line.querySelector('[data-nk-qty]'); if (q) q.textContent = item.quantity;
    const lt = line.querySelector('[data-nk-line-total]'); if (lt) { lt.textContent = curFmt(perTinCents(item.final_line_price, item.quantity), latest && latest.currency); lt.removeAttribute('data-nk-updating'); }
    const was = line.querySelector('.nk-cart__was');
    if (was) { if (item.original_line_price !== item.final_line_price) { was.style.display=''; was.textContent = curFmt(perTinCents(item.original_line_price, item.quantity), latest && latest.currency); } else { was.style.display='none'; } }
    // AUTHORITATIVE chip reconcile (Scout 2026-09-09): rebuild the line-level .nk-chip badges from
    // the server's real line_level_discount_allocations. This confirms/corrects the optimistic
    // chip painted on tap, and makes discount chips work for ANY product/discount without a
    // section-render round-trip — the fix for "discount takes too long to display".
    syncLineChips(line, item);
  }

  // Rebuild a line's .nk-chip badges to exactly match Shopify's authoritative discount data.
  // Markup mirrors the Liquid: <div class="nk-chip"><span class="nk-chip__s">SAVE $x.xx</span></div>
  // inserted before .nk-cart__ctl.
  function syncLineChips(line, item) {
    // Chip now lives in .nk-cart__body-bottom AFTER the qty/remove row (qty up, savings under).
    const host = line.querySelector('.nk-cart__body-bottom') || line.querySelector('.nk-cart__body');
    if (!host) return;
    const allocs = (item.line_level_discount_allocations || []);
    const existing = host.querySelectorAll('.nk-chip');
    // remove surplus chips
    for (let i = allocs.length; i < existing.length; i++) existing[i].remove();
    allocs.forEach((d, idx) => {
      let chip = host.querySelectorAll('.nk-chip')[idx];
      if (!chip) {
        chip = document.createElement('div');
        chip.className = 'nk-chip';
        chip.innerHTML = '<span class="nk-chip__s"></span>';
        host.appendChild(chip); // after the ctl row
      }
      // Chip shows ONLY "SAVE $XX.XX" (title dropped — was truncating in the capsule). Scout 2026-09-09.
      const s = chip.querySelector('.nk-chip__s'); if (s) s.textContent = 'YOU SAVE ' + curFmt(d.amount || 0, latest && latest.currency);
    });
  }

  // Does the DOM already contain every cart line? If not (e.g. an item was just added),
  // we must render the missing lines. We do that via Shopify's Section Rendering API so the
  // line markup exactly matches the Liquid (prices, discounts, variant, subscription, etc.).
  function domHasAllLines(cart) {
    for (const it of cart.items) {
      if (!H.querySelector('[data-nk-line][data-key="' + cssKey(it.key) + '"]')) return false;
    }
    return true;
  }

  async function renderLinesFromSection() {
    const sectionId = H.dataset.sectionId;
    if (!sectionId) return false;
    try {
      const r = await fetch('/?section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } });
      if (!r.ok) return false;
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshLines = doc.querySelector('[data-nk-lines]');
      const liveLines = H.querySelector('[data-nk-lines]');
      if (freshLines && liveLines) { liveLines.innerHTML = freshLines.innerHTML; return true; }
    } catch (e) {}
    return false;
  }

  // reconcile(cart, opts)
  //   opts.sectionHTML : pre-rendered NOOKS header/cart section HTML returned in the SAME
  //                      /cart/add|change request (bundled section rendering). When present we
  //                      swap authoritative Liquid straight in — this is what keeps discount
  //                      chips (.nk-chip) and cart-level discounts ([data-nk-disc]) truthful,
  //                      not just the numeric subtotal (Scout 2026-09-09).
  //   opts.forceSection: force a section pull even if every line already exists in the DOM,
  //                      so discount UI rebuilds when a bundle threshold is crossed.
  async function reconcile(cart, opts) {
    opts = opts || {};
    latest = cart;
    if (opts.sectionHTML) {
      swapLinesFromHTML(opts.sectionHTML);
    } else if (!domHasAllLines(cart) || opts.forceSection) {
      // Missing a line (fresh add) OR a discount-affecting change: pull authoritative Liquid.
      await renderLinesFromSection();
    } else {
      // remove DOM lines no longer in cart
      H.querySelectorAll('[data-nk-line]').forEach(l => {
        if (!cart.items.find(i => cssKey(i.key) === l.dataset.key)) collapseAndRemove(l);
      });
    }
    cart.items.forEach(paintLine);
    paintTotals(cart);
    // Keep the discount signature in sync with what's now RENDERED, so the next qty change
    // can tell whether a threshold was crossed (and only then pay for a section re-render).
    lastDiscSig = discountSig(cart);
  }

  // Swap the drawer lines (and discount UI) from an already-fetched section HTML string.
  function swapLinesFromHTML(html) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshLines = doc.querySelector('[data-nk-lines]');
      const liveLines = H.querySelector('[data-nk-lines]');
      if (freshLines && liveLines) { liveLines.innerHTML = freshLines.innerHTML; return true; }
      // Some section wrappers nest the whole nk-cart; fall back to swapping that.
      const freshCart = doc.querySelector('#nk-cart [data-nk-lines]') || doc.querySelector('#nk-cart');
      if (freshCart && liveLines) { liveLines.innerHTML = (freshCart.querySelector ? (freshCart.querySelector('[data-nk-lines]') || freshCart).innerHTML : freshCart.innerHTML); return true; }
    } catch (e) {}
    return false;
  }

  function cssKey(k){ return String(k); }

  function collapseAndRemove(line){
    line.style.height = line.offsetHeight + 'px';
    requestAnimationFrame(() => { line.classList.add('nk-cart__line--removing'); line.style.height='0px'; line.style.opacity='0'; });
    setTimeout(() => line.remove(), 240);
  }

  /* ---------------- server sync ---------------- */
  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  // Flush pending qty changes. Sends the LATEST desired qty per line only.
  // SPEED (Scout 2026-09-09, "Debounce Baby"): LEADING-EDGE fire. The first change flushes
  // almost immediately (40ms — just enough to coalesce a same-frame inc/dec) so a single tap
  // reconciles fast; only genuine rapid repeat-taps get trailing-debounced (110ms) to avoid
  // hammering /cart/change.js. Net effect: discount + subtotal update ~instantly on one tap,
  // but a frantic 5-tap burst still collapses to one authoritative round-trip.
  let leadingFired = false;
  function scheduleSync() {
    clearTimeout(syncTimer);
    if (!inFlight && !leadingFired) {
      leadingFired = true;
      syncTimer = setTimeout(flush, 40);   // leading edge: near-instant first reconcile
    } else {
      syncTimer = setTimeout(flush, 110);  // trailing: coalesce rapid repeats
    }
  }
  async function flush() {
    if (inFlight) { scheduleSync(); return; }
    const entries = Object.entries(pending);
    if (!entries.length) return;
    inFlight = true;
    // process sequentially (Shopify line indexes shift on removals; safest one-at-a-time by key)
    for (const [key, qty] of entries) {
      // Snapshot the version we're about to send so a newer tap that lands mid-request
      // is NOT silently discarded (rapid-tap race fix, Scout 2026-09-09).
      const sentSeq = pendingSeq[key];
      let ok = false;
      // KEY REMAP (Scout 2026-09-09 bounce fix): Shopify regenerates the line key on every mutation,
      // so a key captured before the last reconcile may already be dead. If this key isn't in the
      // latest authoritative cart, remap to the CURRENT key for the same variant so change.js finds
      // the line (otherwise the change no-ops and the qty "bounces back").
      let sendKey = key;
      if (latest && latest.items && !latest.items.some(i => cssKey(i.key) === key)) {
        const wantVid = parseInt((key.split(':')[0] || ''), 10);
        const match = latest.items.find(i => i.variant_id === wantVid || i.id === wantVid);
        if (match) sendKey = cssKey(match.key);
      }
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: sendKey, quantity: qty })
        });
        // Failure recovery: /cart/change can return a non-cart error object (inventory,
        // selling-plan state, transient). Do NOT feed that to reconcile() as if it were a cart.
        if (!r.ok) {
          const authoritative = await fetchCart().catch(() => null);
          if (authoritative) { latest = authoritative; reconcile(authoritative); broadcast(authoritative); }
          // leave pending[key] in place ONLY if a newer tap arrived; otherwise drop it so
          // we don't loop forever on a genuinely rejected change.
          if (pendingSeq[key] === sentSeq) { delete pending[key]; delete pendingSeq[key]; }
          continue;
        }
        const cart = await r.json();
        latest = cart;
        ok = true;
        // Only clear this line if no NEWER tap arrived while the request was in flight.
        if (pendingSeq[key] === sentSeq) { delete pending[key]; delete pendingSeq[key]; }
        // The discount chip is already painted optimistically on tap (paintBalmChip), and
        // paintLine/paintTotals below repaint authoritative numbers from this cart JSON — so we
        // do NOT need a section-render round-trip on the happy path. We only pull fresh Liquid if
        // a DOM line is missing (safety), which reconcile() handles via domHasAllLines. This is
        // what removes the remaining "discount takes too long" lag. (Scout 2026-09-09.)
        discountSignatureChanged(cart); // keep signature in sync (no forced render)
        await reconcile(cart);
        broadcast(cart);
      } catch (e) { /* network error: keep pending for retry on next flush */ }
    }
    inFlight = false;
    leadingFired = false; // allow the next distinct interaction to fire on its leading edge
    if (Object.keys(pending).length) scheduleSync();
  }

  function broadcast(cart){
    try { document.dispatchEvent(new CustomEvent('nooks:cart:updated', { detail: cart })); } catch(e){}
  }

  // Discount "signature" = which discounts + how many chips are live. When it changes vs the
  // last-rendered cart, the .nk-chip / [data-nk-disc] Liquid must be rebuilt from a section pull;
  // when it's unchanged, repainting numbers is enough (no extra round-trip). (Scout 2026-09-09.)
  // (lastDiscSig is declared up top as a var to avoid any temporal-dead-zone on early reconcile.)
  function discountSig(cart){
    if (!cart) return '';
    const line = (cart.items || []).map(i => (i.line_level_discount_allocations || []).length + ':' + (i.line_level_total_discount || 0)).join('|');
    const cartLvl = (cart.cart_level_discount_applications || cart.discount_applications || []).map(d => (d.title || '') + '=' + (d.total_allocated_amount || d.total_allocated || 0)).join('|');
    return line + '#' + cartLvl;
  }
  function discountSignatureChanged(cart){
    const sig = discountSig(cart);
    const changed = (lastDiscSig !== null && sig !== lastDiscSig);
    lastDiscSig = sig;
    return changed;
  }

  /* ---------------- optimistic qty ---------------- */
  function optimisticSet(line, newQty) {
    const key = line.dataset.key;
    const qEl = line.querySelector('[data-nk-qty]');
    const cur = parseInt((qEl && qEl.textContent) || '0', 10) || 0;
    newQty = Math.max(0, newQty);
    if (newQty === cur) return;

    if (newQty === 0) { collapseAndRemove(line); }
    else if (qEl) { qEl.textContent = newQty; }

    // Optimistic COUNT (instant, always safe) + optimistic MONEY for KNOWN bundle tiers.
    // Bundle discounts are non-linear across thresholds (1->2->3), so we must NOT do a naive
    // unit*qty. Instead we map the KNOWN Everywhere Balm price ladder (qty -> exact final
    // subtotal after the live Buy2/Buy3 automatic discounts) and paint it INSTANTLY, so the
    // discounted total appears to update on tap. The server /cart/change reconcile then confirms
    // (authoritative) ~40ms later. If we can't confidently map the line, we fall back to the
    // safe "updating" state and let the server own the money. (Scout 2026-09-09, "Debounce Baby".)
    //
    // Balm discounted FINAL line price is FORMULA-based (not a fixed 1/2/3 map) so it stays correct
    // for ANY qty a user can reach in the cart with +/- (4, 5, 6...). Live discounts:
    //   qty 1 -> $39.95        (no discount)
    //   qty 2 -> $74.95        ("Buy 2, Save $4.95")
    //   qty>=3 -> $34.98/tin   ("Buy 3+, 12.43% off each": round(3995*0.8757)=3498)
    // Bug fixed 2026-09-09 (device audit): the old 3-entry map showed garbage subtotals at qty>=4.
    if (latest) {
      const optimisticCount = Math.max(0, latest.item_count + (newQty - cur));
      $all('[data-nk-count]').forEach(e => e.textContent = optimisticCount);

      // Identify this line in the authoritative cart to read its current final_line_price, then
      // confirm it's the balm by checking the CURRENT qty's expected price matches what's charged.
      const authItem = latest.items && latest.items.find(i => cssKey(i.key) === key);
      const curLineCents = authItem ? authItem.final_line_price : null;
      const curQty = authItem ? authItem.quantity : cur;
      // isBalm: the current line's charged price matches this qty's expected balm price (any qty).
      const isBalm = curLineCents != null && balmLineCents(curQty) === curLineCents;
      const nextLineCents = (isBalm && newQty >= 1) ? balmLineCents(newQty) : null;

      const lt = line.querySelector('[data-nk-line-total]');
      if (nextLineCents != null) {
        // We know the exact discounted numbers — paint money INSTANTLY, no grey wait.
        const delta = nextLineCents - (curLineCents || 0);
        const optSubtotal = Math.max(0, latest.total_price + delta);
        if (lt) lt.textContent = curFmt(perTinCents(nextLineCents, newQty), latest.currency);
        $all('[data-nk-subtotal]').forEach(e => e.textContent = curFmt(optSubtotal, latest.currency));
        const away = threshold - optSubtotal;
        $all('[data-nk-away]').forEach(e => e.textContent = away > 0
          ? curFmt(away, latest.currency).toUpperCase() + ' AWAY FROM FREE SHIPPING'
          : 'FREE SHIPPING UNLOCKED');
        const pct = Math.max(0, Math.min(100, Math.round(optSubtotal / threshold * 100)));
        $all('[data-nk-bar]').forEach(e => { e.style.width = pct + '%'; });
        // strikethrough "was" = full undiscounted price, shown only when a discount is active.
        const was = line.querySelector('.nk-cart__was');
        if (was) {
          const undiscounted = 3995 * newQty;
          if (undiscounted !== nextLineCents) { was.style.display = ''; was.textContent = curFmt(perTinCents(undiscounted, newQty), latest.currency); }
          else { was.style.display = 'none'; }
        }
        // OPTIMISTIC DISCOUNT CHIP: paint the line-level .nk-chip "SAVE $x.xx" INSTANTLY.
        paintBalmChip(line, newQty);
      } else {
        // Unknown line (not the balm, or an untracked tier): keep the safe frozen-then-reconcile
        // behaviour so we never SHOW a price Shopify won't charge.
        $all('[data-nk-subtotal]').forEach(e => e.setAttribute('data-nk-updating', '1'));
        if (lt) lt.setAttribute('data-nk-updating', '1');
        $all('[data-nk-away]').forEach(e => e.setAttribute('data-nk-updating', '1'));
      }
    }

    pending[key] = newQty;
    pendingSeq[key] = (pendingSeq[key] || 0) + 1;
    scheduleSync();
  }

  // Instantly render the balm's line-level discount chip for a given qty. Mirrors the Liquid
  // markup exactly (<div class="nk-chip"><span class="nk-chip__s">SAVE $x.xx</span></div>).
  // <span class="nk-chip__s">SAVE $x.xx</span></div>) so the authoritative server reconcile is a
  // no-op swap, never a visible jump. (Scout 2026-09-09, "Debounce Baby".)
  // Balm optimistic pricing (Dani-confirmed 2026-09-09: "Buy 3+, 12.43% off each" is a PER-TIN
  // discount applied to EVERY tin once qty >= 3 — so it scales, it does not cap at the 3-bundle).
  // Final line price in CENTS for any qty:
  //   qty 1 -> $39.95              (no discount)
  //   qty 2 -> $74.95              ("Buy 2, Save $4.95")
  //   qty>=3 -> 12.43% off the WHOLE line, rounded on the line total (matches Shopify: 3 tins ring
  //             $104.95, i.e. round(11985*0.8757)=10495 — NOT per-tin rounding which gives $104.94).
  function balmLineCents(qty){
    qty = Math.max(0, parseInt(qty,10)||0);
    if (qty <= 0) return 0;
    if (qty === 1) return 3995;
    if (qty === 2) return 7495;
    return Math.round(3995 * qty * (1 - 0.1243)); // qty>=3: 12.43% off each, rounded on line total
  }
  function balmSaveCents(qty){
    qty = Math.max(0, parseInt(qty,10)||0);
    if (qty < 2) return 0;
    return (3995 * qty) - balmLineCents(qty); // full price minus discounted line price
  }
  function paintBalmChip(line, qty) {
    const host = line.querySelector('.nk-cart__body-bottom') || line.querySelector('.nk-cart__body');
    if (!host) return;
    let chip = host.querySelector('.nk-chip');
    const save = balmSaveCents(qty);
    if (save <= 0) { if (chip) chip.remove(); return; } // qty<2 => no discount, no chip
    if (!chip) {
      chip = document.createElement('div');
      chip.className = 'nk-chip';
      chip.innerHTML = '<span class="nk-chip__s"></span>';
      host.appendChild(chip); // after the ctl row (qty up, savings under)
    }
    // Chip shows ONLY "SAVE $XX.XX" (Scout 2026-09-09).
    const s = chip.querySelector('.nk-chip__s'); if (s) s.textContent = 'YOU SAVE ' + curFmt(save, latest && latest.currency);
  }

  /* ---------------- delegation (bound once, survives re-render) ---------------- */
  H.addEventListener('click', function (e) {
    // qty + remove within a line
    const line = e.target.closest('[data-nk-line]');
    if (line) {
      const qEl = line.querySelector('[data-nk-qty]');
      const cur = parseInt((qEl && qEl.textContent) || '0', 10) || 0;
      if (e.target.closest('[data-nk-inc]')) { e.preventDefault(); optimisticSet(line, cur + 1); return; }
      if (e.target.closest('[data-nk-dec]')) { e.preventDefault(); optimisticSet(line, cur - 1); return; }
      if (e.target.closest('[data-nk-remove]')) { e.preventDefault(); optimisticSet(line, 0); return; }
    }
  });

  /* ---------------- open / add-to-cart ---------------- */
  function openCart() {
    const openBtn = H.querySelector('[data-nk-open="cart"]');
    if (openBtn) openBtn.click();
  }
  async function refresh() {
    try { const cart = await fetchCart(); reconcile(cart); return cart; } catch (e) { return null; }
  }
  // Refresh on open so the drawer always shows current server state.
  const openBtn = H.querySelector('[data-nk-open="cart"]');
  if (openBtn) openBtn.addEventListener('click', () => { refresh(); });

  // NOTE (Scout 2026-09-07): we DELIBERATELY do NOT intercept add-to-cart form submits here.
  // Dawn's product-form.js already owns the PDP add (it does /cart/add + section render and
  // publishes PUB_SUB_EVENTS.cartUpdate). A second submit-listener here caused a DOUBLE add
  // (two /cart/add round-trips per click) = the "adds slowly" bug and a race on which drawer
  // showed. Instead we SUBSCRIBE to Dawn's cart-update event below and mirror it into .nk-cart.

  // Subscribe to Dawn's cart-update (product-form, quick-add, etc.). When an item is ADDED
  // (source is a product form / quick-add, i.e. not our own in-drawer qty changes), refresh
  // the .nk-cart lines and open the drawer. pubsub.js loads in <head> so subscribe() exists;
  // guard anyway in case of load-order edge cases.
  function bindCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      const src = payload && payload.source;
      // Ignore updates we originated inside the drawer (qty/remove) to avoid re-opening on tap.
      if (src === 'nooks-header') return;
      // If Dawn handed us the fresh cart JSON, reconcile from it directly; else re-fetch.
      const cart = payload && payload.cartData;
      const openIfAdd = src === 'product-form' || src === 'quick-add' || src === 'quick-order-list' || src === undefined;
      // SPEED FIX (Scout 2026-09-07): open the drawer IMMEDIATELY on add so it feels instant,
      // then reconcile lines/totals in the background. Previously we awaited reconcile()/refresh()
      // before opening, which made add-to-cart feel laggy. If Dawn handed us fresh cart JSON we
      // paint from it right away; otherwise we open now and let refresh() fill in.
      if (openIfAdd) openCart();
      Promise.resolve(cart && cart.items ? reconcile(cart) : refresh());
    });
    return true;
  }
  if (!bindCartUpdate()) {
    // pubsub not ready yet: retry on next tick / after load
    document.addEventListener('DOMContentLoaded', bindCartUpdate, { once: true });
    window.addEventListener('load', bindCartUpdate, { once: true });
  }

  // Public hooks for the instant.so / bundle shim → single cart, no orphaned Dawn drawer.
  window.nooksCartRefresh = refresh;

  // Reconcile the drawer from a cart JSON we ALREADY have (no network). Used by the ATC helper
  // to settle authoritative totals in the background AFTER the drawer has already popped open.
  // (Scout 2026-09-09, "Debounce Baby".)
  window.nooksCartReconcile = function (cart) {
    if (cart && cart.items) { try { reconcile(cart); } catch (e) {} }
  };

  // openCart used by bundle/instant/canonical adds.
  // FASTEST path (Scout 2026-09-09, "Debounce Baby"): the caller already did ONE /cart/add.js with
  // bundled section rendering. It hands us { cart?, sectionHTML? } and we:
  //   1) open the drawer INSTANTLY,
  //   2) if sectionHTML is present, swap the drawer lines from it RIGHT NOW (no fetch) — so the
  //      added item is visible on the same frame the add resolved,
  //   3) if a full cart JSON came too, reconcile exact numbers; otherwise the caller settles
  //      totals in the background via nooksCartReconcile.
  // Only a caller that passes NOTHING at all falls back to a fetch (refresh()).
  window.nooksOpenCart = async function (payload) {
    openCart(); // open instantly so it feels snappy
    // CRITICAL (Scout 2026-09-09): the drawer was server-rendered while the cart may have been
    // EMPTY, which leaves .nk-cart--empty on (hides .nk-cart__foot => hides checkout) AND the
    // checkout button [disabled]. On the fast add-path we must clear that state IMMEDIATELY so the
    // Checkout button is live the moment the item shows — not after the background reconcile.
    // (Bug found in the device conversion-path audit: checkout stayed disabled/hidden on first add.)
    ensureNonEmptyUI();
    if (payload && payload.cart && payload.cart.items) {
      // Have authoritative cart now → full reconcile (numbers + lines) using the section HTML.
      try { await reconcile(payload.cart, { sectionHTML: payload.sectionHTML }); } catch (e) {}
    } else if (payload && payload.sectionHTML) {
      // No cart JSON yet, but we DO have the freshly-rendered section: paint lines immediately so
      // the new item shows on the same frame. Totals settle via the caller's background reconcile.
      try { swapLinesFromHTML(payload.sectionHTML); } catch (e) {}
      ensureNonEmptyUI(); // re-assert after line swap
    } else {
      await refresh();
    }
  };

  // Force the drawer OUT of its empty state and ENABLE the checkout button right now. Safe to call
  // repeatedly. Used on the fast add-path so checkout is never a dead button on the first add.
  function ensureNonEmptyUI(){
    try {
      const cartEl = CART();
      if (cartEl) cartEl.classList.remove('nk-cart--empty');
      // enable + reveal the checkout submit (it may carry a server-rendered [disabled] from empty).
      H.querySelectorAll('button[name="checkout"]').forEach(function(b){
        b.disabled = false; b.removeAttribute('disabled');
        b.style.visibility = ''; b.style.opacity = '';
      });
      // reveal the foot in case CSS empty-state hid it before the class was removed
      H.querySelectorAll('.nk-cart__foot').forEach(function(f){ f.style.display = ''; });
    } catch(e){}
  }

  // NOTE: no eager /cart.js on cold load. Liquid has already server-rendered the real cart into
  // the drawer, and we no longer extrapolate optimistic money, so a baseline fetch on arrival is
  // unnecessary. A brand-new Meta visitor who never opens the bag makes zero cart requests. The
  // drawer still refreshes on open (openBtn listener above). (Scout 2026-09-09.)

  /* ---------------- cart note (persist to Shopify) ---------------- */
  H.addEventListener('input', function (e) {
    const ta = e.target.closest('[data-nk-note]');
    if (!ta) return;
    clearTimeout(ta._t);
    ta._t = setTimeout(() => {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: ta.value })
      }).catch(() => {});
    }, 500);
  });

  /* ---------------- predictive search ---------------- */
  const input = H.querySelector('[data-nk-search-input]');
  const results = H.querySelector('[data-nk-search-results]');
  if (input && results) {
    const empty = results.innerHTML;
    let t;
    let searchSeq = 0;          // monotonic query token (race guard)
    let searchAbort = null;     // in-flight AbortController
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = empty; if (searchAbort) { searchAbort.abort(); searchAbort = null; } return; }
      t = setTimeout(async () => {
        // Cancel any older in-flight request and stamp this one so a slow earlier
        // response can never overwrite newer results (Scout 2026-09-09).
        if (searchAbort) { try { searchAbort.abort(); } catch (e) {} }
        const mySeq = ++searchSeq;
        const ctrl = ('AbortController' in window) ? new AbortController() : null;
        searchAbort = ctrl;
        try {
          const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=6', ctrl ? { signal: ctrl.signal } : undefined);
          const d = (await r.json()).resources.results;
          if (mySeq !== searchSeq) return; // a newer query already superseded this one
          const items = [].concat(d.products || [], d.pages || [], d.articles || []);
          results.innerHTML = '<span class="nk-panel__label" style="padding:0">RESULTS</span>' +
            (items.length ? items.map(i => '<a href="' + i.url + '">' + i.title + '</a>').join('') : '<span class="nk-cart__note">Nothing by that name.</span>');
        } catch (e) { /* aborted or network error — ignore, newer query owns the UI */ }
      }, 200);
    });
  }
})();
